import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import { withIntl, IntlProps } from 'ha/i18n';
import { Typography } from 'ha/ui/next/Typography';
import Grid from 'ha/ui/next/Grid';
import Paper from 'ha/ui/next/Paper';
import Img from 'ha/ui/next/Img';
import units from 'ha/theme/units';
import Link from 'ha/ui/next/Link';
import LazyComponent from 'ha/components/LazyComponent';
import { TopCity } from '../../types';

export const styles = createStyles({
  root: {
    overflow: 'hidden',
    paddingBottom: units.rem(1.125),
    transition: 'transform 0.5s ease',
    '&:hover': {
      transform: 'scale(1.025)',
    },
  },
  imageWrapper: {
    position: 'relative',
    height: units.rem(15.25),
    marginBottom: units.rem(1),
  },
  image: {
    position: 'absolute',
    objectFit: 'cover',
    height: '100%',
    width: '100%',
  },
  name: {
    fontSize: units.rem(1.75),
    marginBottom: units.rem(1),
    zIndex: 1,
  },
  shadowForName: {
    top: '70%',
    bottom: 0,
    left: 0,
    right: 0,
    position: 'absolute',
    background: 'linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent)',
  },
  listings: {
    fontWeight: 'bold',
    marginBottom: units.rem(0.5),
  },
  description: {
    padding: units.yx(0, 1),
  },
});

interface Props {
  listingsCount?: number;
}

export const CityCard: React.SFC<
  Props & TopCity & IntlProps & WithStyles<typeof styles>
> = ({
  imageUrl,
  name,
  urls,
  listingsCount = 0,
  description,
  intl: { T, lang },
  classes,
}) => (
  <Link to={urls[lang]}>
    <Paper className={classes.root}>
      <Grid
        container
        alignItems="flex-end"
        justify="center"
        className={classes.imageWrapper}
      >
        <LazyComponent bottomOffset="-100px" scrollableAncestor="window">
          <Img src={imageUrl} className={classes.image} alt={T(name)} />
        </LazyComponent>
        <Typography.H3
          className={classes.name}
          color="white"
          data-test-locator="Home CityCard Name"
        >
          {T(name)}
        </Typography.H3>
        <div className={classes.shadowForName} />
      </Grid>
      {listingsCount !== 0 && (
        <Typography.Caption
          align="center"
          color="muted"
          className={classes.listings}
          data-test-locator="Home CityCard Listings"
        >
          {listingsCount} {T('Listings')}
        </Typography.Caption>
      )}
      <Typography.Paragraph
        align="center"
        className={classes.description}
        data-test-locator="Home CityCard Description"
      >
        {T(description)}
      </Typography.Paragraph>
    </Paper>
  </Link>
);

export default withStyles(styles)(withIntl(CityCard));
